import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CalendarGrid = ({ 
  currentDate, 
  birthdays = [], 
  onDateClick, 
  onBirthdayClick,
  className = '' 
}) => {
  const today = new Date();
  const year = currentDate?.getFullYear();
  const month = currentDate?.getMonth();

  // Get first day of month and number of days
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay?.getDate();
  const startingDayOfWeek = firstDay?.getDay();

  // Create calendar days array
  const calendarDays = [];
  
  // Add empty cells for days before month starts
  for (let i = 0; i < startingDayOfWeek; i++) {
    calendarDays?.push(null);
  }
  
  // Add days of the month
  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays?.push(day);
  }

  // Get birthdays for a specific date
  const getBirthdaysForDate = (day) => {
    if (!day) return [];
    
    return birthdays?.filter(birthday => {
      const birthDate = new Date(birthday.dateOfBirth);
      return birthDate?.getDate() === day && birthDate?.getMonth() === month;
    });
  };

  // Check if date is today
  const isToday = (day) => {
    if (!day) return false;
    return (today?.getDate() === day &&
    today?.getMonth() === month && today?.getFullYear() === year);
  };

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <div className={`bg-surface rounded-lg border border-border shadow-card ${className}`}>
      {/* Week day headers */}
      <div className="grid grid-cols-7 border-b border-border">
        {weekDays?.map((day) => (
          <div
            key={day}
            className="p-3 text-center text-sm font-medium text-text-secondary bg-muted"
          >
            {day}
          </div>
        ))}
      </div>
      {/* Calendar grid */}
      <div className="grid grid-cols-7">
        {calendarDays?.map((day, index) => {
          const dayBirthdays = getBirthdaysForDate(day);
          const hasMultipleBirthdays = dayBirthdays?.length > 1;
          const isCurrentDay = isToday(day);

          return (
            <div
              key={index}
              className={`min-h-[80px] lg:min-h-[100px] border-r border-b border-border p-2 cursor-pointer hover:bg-muted/50 transition-micro ${
                !day ? 'bg-muted/30' : ''
              } ${isCurrentDay ? 'bg-primary/10 border-primary/30' : ''}`}
              onClick={() => day && onDateClick(day)}
            >
              {day && (
                <>
                  {/* Date number */}
                  <div className={`text-sm font-medium mb-1 ${
                    isCurrentDay ? 'text-primary font-semibold' : 'text-text-primary'
                  }`}>
                    {day}
                    {isCurrentDay && (
                      <span className="ml-1 text-xs bg-primary text-primary-foreground px-1 rounded">
                        Today
                      </span>
                    )}
                  </div>

                  {/* Birthday indicators */}
                  {dayBirthdays?.length > 0 && (
                    <div className="space-y-1">
                      {hasMultipleBirthdays ? (
                        <div
                          onClick={(e) => {
                            e?.stopPropagation();
                            onBirthdayClick(dayBirthdays);
                          }}
                          className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full text-center hover:bg-primary/90 transition-micro"
                        >
                          {dayBirthdays?.length} birthdays
                        </div>
                      ) : (
                        <div
                          onClick={(e) => {
                            e?.stopPropagation();
                            onBirthdayClick(dayBirthdays?.[0]);
                          }}
                          className="flex items-center space-x-1 bg-primary/10 hover:bg-primary/20 rounded p-1 transition-micro"
                        >
                          <div className="w-6 h-6 rounded-full overflow-hidden bg-muted flex-shrink-0">
                            {dayBirthdays?.[0]?.avatar ? (
                              <Image
                                src={dayBirthdays?.[0]?.avatar}
                                alt={dayBirthdays?.[0]?.name}
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center">
                                <Icon name="User" size={12} className="text-text-secondary" />
                              </div>
                            )}
                          </div>
                          <span className="text-xs text-text-primary truncate flex-1">
                            {dayBirthdays?.[0]?.name}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarGrid;